import { GetLeaderboardResponse, YourLeaderboardPosition } from './types'
import { http } from '@/shared/http.ts'

export const getTotalTimeLeaderboard = async (
  token: string,
  page: number,
  size: number
) => {
  return await http.get<GetLeaderboardResponse>('/leaderboard/time', {
    token,
    queryParams: {
      page,
      size,
    }
  })
}

export const getAccountValueLeaderboard = async (
  token: string,
  page: number,
  size: number
) => {
  return await http.get<GetLeaderboardResponse>('/leaderboard/steam', {
    token,
    queryParams: {
      page,
      size,
    }
  })
}

export const getBalanceLeaderboard = async (
  token: string,
  page: number,
  size: number
) => {
  return await http.get<GetLeaderboardResponse>('/leaderboard/token', {
    token,
    queryParams: {
      page,
      size,
    }
  })
}

export const getGigiLeaderboard = async (
  token: string,
  page: number,
  size: number
) => {
  return await http.get<GetLeaderboardResponse>('/leaderboard/gigi', {
    token,
    queryParams: {
      page,
      size,
    }
  })
}

export const getYourLeaderboardPosition = async (token: string): Promise<YourLeaderboardPosition> => {
  return await http.get<YourLeaderboardPosition>('/leaderboard/you', {
    token,
  })
}
